import { Appointments } from '@devexpress/dx-react-scheduler-material-ui'

export const Appointment = ({ onClick, ...restProps }: any) => {
  return <Appointments.Appointment onClick={onClick} style={{ backgroundColor: '#FC3E6F' }} {...restProps} />
}
